<template>
  <div class="main">
    <div class="top">
      <div class="con">
        <div class="logo">
          <!--          <img :src="img_baseurl + 'logo_ico.png'" />-->
          <img :src="img_baseurl + 'logo_ico_heluo.png'" />
          <div>{{ app_name }}数据恢复</div>
        </div>
        <div class="wel">
          专业的数据恢复大师
        </div>
      </div>
    </div>

    <div class="banner">
      <div class="bg"><img :src="img_baseurl + 'banner.png'" /></div>
      <div class="info">
        <div class="desc">
          <div class="big">
            <span>{{ app_name }}</span>数据恢复，<br />
                                       让数据恢复更专业
          </div>
          <div class="small">
            流程专业/数据安全/客户第一/售后无忧
          </div>
        </div>
        <div class="codes">
          <div class="code" style="margin-right: 50px;">
            <div :style="{'background-image':'url('+require('@/assets/qrcode_android.png')+')'}">
              <div ref="qrCode_ios" id="qrCode_ios" />
            </div>
            <div>
              <img :src="img_baseurl + 'btn_load_ios.png'" />
            </div>
            <div>适配系统：IOS</div>
          </div>

          <div class="code">
            <div :style="{'background-image':'url('+require('@/assets/qrcode_android.png')+')'}">
              <div ref="qrCode_android" id="qrCode_android" />
            </div>
            <div>
              <img :src="img_baseurl + 'btn_load_android.png'" />
            </div>
            <div>适配系统：Android</div>
          </div>
        </div>
      </div>
    </div>


    <div class="box_cpzs">
      <img :src="img_baseurl + 'info1.png'" />
    </div>

    <div class="box_youshi">
      <div class="box_label"><img :src="img_baseurl + 'lab_youshi.png'" /></div>
      <div class="detail">
        <div><img :src="img_baseurl + 'youshi1.png'" /></div>
        <div><img :src="img_baseurl + 'youshi2.png'" /></div>
        <div><img :src="img_baseurl + 'youshi3.png'" /></div>
      </div>
    </div>

    <div class="box_changjing">
      <div class="box_label"><img :src="img_baseurl + 'lab_yycj.png'" /></div>
      <div class="detail">
        <div><p>微信聊天<br />记录恢复</p></div>
        <div><p>QQ恢复</p></div>
        <div><p>好友恢复</p></div>
        <div><p>通话记录</p></div>
        <div><p>通讯录</p></div>

        <div><p>微信聊天记录<br />彻底删除</p></div>
        <div><p>短信恢复</p></div>
        <div><p>备忘录</p></div>
        <div><p>微信账单</p></div>
        <div><p>图片/视频</p></div>
      </div>
    </div>

    <div class="box_pinglun">
      <div class="box_label"><img :src="img_baseurl + 'lab_pingjia.png'" /></div>
      <div class="detail">
        <div><img :src="img_baseurl + 'pingjia_1.png'" /></div>
        <div><img :src="img_baseurl + 'pingjia_2.png'" /></div>
      </div>
    </div>

    <!-- <div class="footer" @click="openmiit()">
      苏州迪册信用信息科技有限公司   备案号  苏ICP备2021040451号-3
    </div> -->

    <div class="banquan_label">
      {{ company_name }}
    </div>
    <div class="banquan">
      <div class="bq_con">
        <div class="con1">
          <span class="pointer" @click.stop="openmiit()">开发者：{{ company_name }}</span>
          <span>软件版本：V 1.0.1</span>
          <span @click="toxieyi(1)" class="pointer">用户协议</span>|<span
            @click="toxieyi(2)" class="pointer"
        >隐私政策</span>
        </div>
        <div class="con2">
          <span>Copyright © 2023 {{ company_name }}</span>
          <span>版权所有</span><span>网站备案号：{{ icp }}</span>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import QRCode from 'qrcodejs2';

const storage = window.sessionStorage;
const _version = 1 

export default {
  name: 'index',
  data() {
    return {
      _version,
      app_name: [
        '何洛',
        '何洛',
      ][_version],
      company_name:[
        '盐城嘉艾斯网络科技有限公司',
        '淮安何河何洛信用信息科技有限公司苏州分公司',
      ][_version],
      icp:[
        '苏ICP备2022032834号-1',
        '苏ICP备2021057242号',
      ][_version],
      account_id : '',
      bd_vid     : '',
      luodi_url  : [
        "https://sjpc3.zzhuifu.cn/port/index/send?name=sjhf1",
        "https://sjpc3.zzhuifu.cn/port/index/send?name=sjhf2",
      ][_version],
      img_baseurl: [
        'https://heluoxinxi-1308577698.cos.ap-nanjing.myqcloud.com/sjpc_zzhuifu_cn/',
        'https://heluoxinxi-1308577698.cos.ap-nanjing.myqcloud.com/sjpc_zzhuifu_cn/',
      ][_version],
    }


  },
  created() {
    const newUploadURL = "https://joint.heheshi.cn/api/collector/baidu-web"
    // console.log(axios.defaults.baseURL);
    //注意这里ios和andorid使用了不同的方法
    let url_ios = this.luodi_url + "&type=ios";
    let url_android = [
      "https://sjpc3.zzhuifu.cn/h5/#/?name=sjhf1",      //+"&type=android"  //type可以不加 后台默认android
      'https://sjpc3.zzhuifu.cn/h5/#/pages/index/index_sjhf2?name=sjhf2',
    ][_version]


    this.account_id = this.$route.query.account_id;
    if (this.$route.query.bd_vid !== undefined) {
      storage.setItem("bd_vid", this.$route.query.account_id);
      storage.setItem("bd_vid", this.$route.query.bd_vid);
      this.bd_vid = this.$route.query.bd_vid;
    }

    const logidUrl = encodeURIComponent(location.href)

    url_ios = newUploadURL + '?logidUrl=' + logidUrl
        + '&account_id=' + (
            this.account_id || 1
        )
        + '&newType=6'
        + '&os=iOS'
        + '&redirectUrl=' + encodeURIComponent(url_ios)

    url_android = newUploadURL + '?logidUrl=' + logidUrl
        + '&account_id=' + (
            this.account_id || 1
        )
        + '&os=Android'
        + '&newType=20'
        + '&redirectUrl=' + encodeURIComponent(url_android)
// https://joint.heheshi.cn/api/collector/baidu-web?logidUrl=http%3A%2F%2Flocalhost%3A9001%2F&account_id=&type=6&redirectUrl=https%3A%2F%2Fsjpc3.zzhuifu.cn%2Fport%2Findex%2Fsend%3Fname%3Dsjhf1%26type%3Dios
    setTimeout(res => {
      console.log(url_ios);
      this.qrCode('ios', url_ios);
      this.qrCode('android', url_android);
    }, 200)
  },
  mounted() {
    document.querySelector('body').setAttribute('style', 'background-color:#ffffff')
  },
  beforeDestroy() {
    document.querySelector('body').removeAttribute('style')
  },
  methods: {
    openmiit() {
      window.open("https://beian.miit.gov.cn", "_blank");
    },
    toxieyi(type) {
      //用户协议(1)  隐私政策(2)
      if (type == 1) {
        this.$router.push({
          path: '/protocol',
        });
      } else if (type == 2) {
        this.$router.push({
          path: '/protocol2',
        });
      }


    },
    qrCode(dom, text) {
      console.log(text);
      //默认为ios
      let dom_qrcode = this.$refs.qrCode_ios;
      if (dom == 'android') {
        dom_qrcode = this.$refs.qrCode_android;
      }
      dom_qrcode.innerHTML = '';//清除上一次生成的二维码，防止刷新生成多个二维码
      new QRCode('qrCode_' + dom, {
        width: 300,//二维码宽度
        height: 300,//二维码高度
        text: text, // 二维码内容
        colorDark: "#000",
        colorLight: "#fff",
        correctLevel: QRCode.CorrectLevel.M,
      });
    },
  },
}
</script>

<style>


.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.top {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;

}

.top > .con {
  width: 1280px;
  height: 95px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

}

.top > .con > .logo {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.top > .con > .logo > img {
  width: 48px;
  height: 48px;
  margin-right: 13px;
}

.top > .con > .logo > div {
  font-size: 18px;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  color: #000000;

}

.top > .con > .wel {
  font-size: 24px;
  font-family: YRDZST-Regular, YRDZST;
  font-weight: 400;
  color: #000000;
}

.banner {
  position: relative;
  width: 1280px;
  height: 872px;
  /* overflow: hidden; */
}

.banner .bg {
  position: absolute;
  width: 1920px;
  height: 872px;
  left: -960px;
  margin-left: 50%;
}

.banner .bg img {
  width: 1920px;
  height: 872px;
}

.banner .info {
  position: absolute;
  display: flex;
  flex-direction: row;
  left: 0px;
  top: 208px;
}


.banner .info .desc {
  display: flex;
  flex-direction: column;

}

.banner .info .desc .big {
  width: 700px;
  height: 274px;
  font-size: 80px;
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 117px;
  text-align: left;
}

.banner .info .desc .big span {
  color: #576FF6;
}

.banner .info .desc .small {
  font-size: 30px;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  color: #FFFFFF;
  text-align: left;

}


.banner .info .codes {
  margin-left: 30px;
  display: flex;
  flex-direction: row;
}

.banner .info .codes .code > div:nth-child(1) {
  width: 250px;
  height: 250px;
  background-size: 250px 250px;
  margin-bottom: 50px;

  display: flex;
  flex-direction: row;
  justify-content: center;


}

.banner .info .codes .code > div:nth-child(1) > div {
  display: flex;
  width: 220px;
  height: 220px;
  margin-top: 15px;

}

.banner .info .codes .code > div:nth-child(2) {
  margin-bottom: 20px;
}

.banner .info .codes .code > div:nth-child(3) {
  font-size: 20px;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
}

.box_cpzs {
  background-color: #F7F8FF;
  width: 100%;
}

.box_youshi {
  display: flex;
  flex-direction: column;
  width: 1280px;
  /* width: 100%; */
  justify-content: center;
}

.box_youshi .box_label {
  margin-top: 90px;
  margin-bottom: 90px;
}

.box_youshi .box_label img {
  width: 192px;
  height: 38px;
}

.box_youshi .detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}

.box_youshi .detail img {
  width: 386px;
  height: 420px;

}

/* 场景 */
.box_changjing {
  display: flex;
  flex-direction: column;
  width: 1280px;
  justify-content: center;
}

.box_changjing .box_label {
  margin-top: 90px;
  margin-bottom: 90px;
}

.box_changjing .box_label img {
  width: 192px;
  height: 38px;
}

.box_changjing .detail {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* justify-content: space-between; */

}

.box_changjing .detail div {
  width: 205px;
  height: 114px;
  background: rgba(87, 111, 246, 0.1);
  border-radius: 30px 30px 30px 30px;
  margin-right: 60px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  /* padding-top:40px;
  box-sizing: border-box; */

  font-size: 24px;
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #576FF6;
  line-height: 28px;
}

.box_changjing .detail div:nth-child(5), .box_changjing .detail div:nth-child(10) {
  margin-right: 0px;
}

.box_changjing .detail div p {
  margin: 0px;

}


/* 评论 */
.box_pinglun {
  display: flex;
  flex-direction: column;
  width: 1280px;
  /* width: 100%; */
  justify-content: center;
}

.box_pinglun .box_label {
  margin-top: 90px;
  margin-bottom: 90px;
}

.box_pinglun .box_label img {
  width: 192px;
  height: 38px;
}

.box_pinglun .detail {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

}

.box_pinglun .detail img {
  width: 620px;
  height: 250px;

}


/*底部版权信息*/
.banquan_label {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 20px 0;

  font-size: 18px;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  color: #333333;
}

.banquan {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #414141;
  padding: 60px 0;
  box-sizing: border-box;
}

.banquan > .bq_con {
  width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 18px;
  font-family: Alibaba PuHuiTi-Regular, Alibaba PuHuiTi;
  font-weight: 400;
  color: #FFFFFF;

}

.banquan > .bq_con > div:nth-child(1) {
  margin-bottom: 30px;
}

.banquan > .bq_con > div > span {
  padding: 0 10px;
}


.footer {
  font-size: 20px;
  color: #333333;
  width: 100%;
  height: 130px;
  display: flex;
  /* background: #F3F8FC; */
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}


</style>
